import { WorkflowsSortAttributes } from '../../generated/types';
import { CountriesService } from '../../services/countriesService';
import { DateTimeService } from '../../services/dateTimeService';
import { TranslationService } from '../../services/translationService';
import { PossibleColumn, SegmentService } from '../segment';

export enum WorkflowsDefaultColumns {
    Action = 'Action',
    CreatedAt = 'createdAt',
    CreatedBy = 'createdBy',
    ExecutedAt = 'executedAt',
    Id = 'id',
    Name = 'name',
    State = 'state',
    Trigger = 'trigger',
    VolunteersSegment = 'volunteersSegment'
}

export class WorkflowsSegmentsService extends SegmentService {
    constructor(
        countriesService: CountriesService,
        dateTimeService: DateTimeService,
        translationService: TranslationService
    ) {
        super(countriesService, dateTimeService, translationService);
    }

    getWorkflowsPossibleColumns(): PossibleColumn[] {
        return [
            {
                slug: WorkflowsDefaultColumns.Id,
                name: this.t('id_51738'),
                isSearchable: true,
                isSortable: true,
                width: 100,
                sortAttribute: WorkflowsSortAttributes.Id
            },
            {
                slug: WorkflowsDefaultColumns.Name,
                name: this.t('nom_de_l_automa_04883'),
                isSearchable: true,
                isSortable: true,
                sortAttribute: WorkflowsSortAttributes.Name
            },
            {
                slug: WorkflowsDefaultColumns.State,
                name: this.t('status_06428')
            },
            {
                slug: WorkflowsDefaultColumns.Trigger,
                name: this.t('d_clencheur_73493')
            },
            {
                slug: WorkflowsDefaultColumns.Action,
                name: this.t('action_44224')
            },
            {
                slug: WorkflowsDefaultColumns.CreatedBy,
                name: this.t('cr_e_par_30622'),
                isSearchable: true
            },
            {
                slug: WorkflowsDefaultColumns.CreatedAt,
                name: this.t('cr_e_le_02658'),
                isSortable: true,
                sortAttribute: WorkflowsSortAttributes.CreatedAt
            },
            {
                slug: WorkflowsDefaultColumns.VolunteersSegment,
                name: this.t('vue_s_lectionn_21556'),
                isSortable: true,
                sortAttribute: WorkflowsSortAttributes.VolunteersSegment
            },
            {
                slug: WorkflowsDefaultColumns.ExecutedAt,
                name: this.t('ex_cut_e_le_99019'),
                isSortable: true,
                sortAttribute: WorkflowsSortAttributes.ExecutedAt
            }
        ];
    }
}
